import { all, call, fork, put, select, takeEvery } from "@redux-saga/core/effects";
import { GET_ETC_MISSING, ON_ADD_ETC_Missing } from "../../constants/ActionTypes";
import { getData, postData, postUploadData } from "../../util/DynamicApi";
import { ShowSmallError, ShowSuccess } from "../../util/MessageHelper";
import { AddEtcMissionSuccess, getEtcMissingSuccess, showEtcMissionMessage,hideEtcMissionLoader } from "../actions";

export const getToken = ({ auth }) => auth.token;

const getMissingRequest = async (token, pageIndex, searchText) =>
    await getData(token, "EtcAdvertising/GetEtcAdvertising", {

        pageIndex: pageIndex,
        searchText: searchText

    })
        .then((missing) => {
            return missing;
        })
        .catch((error) => {
            return error.response.data;;
        });



function* doGetMissing({ payload }) {
    let { pageIndex, searchText } = payload;
    try {
        let token = yield select(getToken);
        const missing = yield call(getMissingRequest, token, pageIndex, searchText);
        if (missing.errorMessage) {
            ShowSmallError(missing.errorMessage);
            yield put(hideEtcMissionLoader());
        } else {
            yield put(getEtcMissingSuccess(missing.data));
        }
    } catch (error) {
        yield put(hideEtcMissionLoader(error));
    }
}

export function* getMissingUser() {
    yield takeEvery(GET_ETC_MISSING, doGetMissing);
}
const addMissingRequest = async (token, data) =>
    await postUploadData(token, "EtcAdvertising/AddEtcAdvertising", data.payload)
        .then((missing) => {
            return missing;
        })
        .catch((error) => {
            return error.response.data;
        });
function* doAddMissing(payload) {
    try {
        let token = yield select(getToken);
        const missing = yield call(addMissingRequest, token, payload);

        if (missing.errorMessage) {

            ShowSmallError(missing.errorMessage);
            yield put(hideEtcMissionLoader());
        } else { 
            yield put(AddEtcMissionSuccess(missing.data));
            ShowSuccess("آگهی ثبت شد","در حال انتقال به درگاه");
           
        }
    } catch (error) {
        yield put(showEtcMissionMessage(error));
    }
}

export function* addMissing() {
    yield takeEvery(ON_ADD_ETC_Missing, doAddMissing);
}
export default function* rootSaga() {
    yield all([
        fork(getMissingUser),
        fork(addMissing)]);
}
